import {
  FireOutlined,
  ClockCircleOutlined,
  SmileOutlined,
  PaperClipOutlined
} from '@ant-design/icons'
import React from "react";

export const pageCollect = [
  {
    icon: () => <ClockCircleOutlined />,
    key: "historyRecordList",
    title: "历史记录",
    content: [],
  },
  // {
  //   icon: () => <FireOutlined />,
  //   key: "dipertmentPopularList",
  //   title: "部门最热",
  //   content: [],
  // },
  {
    icon: () => <SmileOutlined />,
    key: "guessLikeList",
    title: "猜你喜欢",
    content: [],
  },
  {
    icon: () => <PaperClipOutlined />,
    key: "myCollectList",
    title: "我的收藏",
    content: [],
  }
]
